import React from "react";
import {
  defineBlock,
  smartProps,
  useEditor,
  EditableDiv,
  ChildrenBlock,
  useSmartProp,
  useInspectorControl,
} from "@smartfire/gutenberg-react";
import { InnerBlocks } from "@wordpress/block-editor";
import EditableText from "../shared/editable-text";
import style from "./block.module.scss";
import {
  PanelBody,
  PanelRow,
  SelectControl,
  ToggleControl,
} from "@wordpress/components";
import { ReactComponent as BackImg } from "./logo_light.svg";

function Inspector() {
  const [theme, setTheme] = useSmartProp("theme");
  const [perLine, setPerLine] = useSmartProp("perLine");
  const [backLogo, setBackLogo] = useSmartProp("backLogo");

  return (
    <>
      <PanelBody title="Configuration affichage" initialOpen={true}>
        <PanelRow>
          <SelectControl
            label="Thème"
            options={[
              { label: "Thème blanc", value: "white" },
              { label: "Thème bleu", value: "blue" },
              { label: "Thème transparent", value: "transparent" },
            ]}
            value={theme}
            onChange={(value) => setTheme(value)}
          />
        </PanelRow>
        <PanelRow>
          <SelectControl
            label="Icones par ligne"
            options={[
              { label: "3 par ligne", value: "3" },
              { label: "4 par ligne", value: "4" },
            ]}
            value={perLine}
            onChange={(value) => setPerLine(value)}
          />
        </PanelRow>
        <PanelRow>
          <ToggleControl
            label="Logo en fond"
            checked={backLogo}
            onChange={(value) => setBackLogo(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ title, theme, perLine, text, backLogo }) {
  const { isEditing } = useEditor();
  useInspectorControl(Inspector);

  return (
    <div
      id="encarts-icones"
      className={
        theme === "blue"
          ? style.blockBlue
          : theme === "white"
          ? style.blockWhite
          : style.blockTransparent
      }
    >
      {backLogo && <BackImg className={style.backLogo} />}
      <div className={style.content}>
        <EditableText className={style.title} tagName="h2" smartProp="title" />
        <div className={style.tiret} />
        {(isEditing || (!isEditing && text !== "")) && (
          <EditableDiv
            className={style.text}
            smartProp="text"
            placeholder={"Entrez un texte"}
          />
        )}
        {isEditing ? (
          <div
            className={
              perLine === "3" ? style.children3admin : style.children4admin
            }
          >
            <InnerBlocks allowedBlocks={["smartfire/encart"]} />
          </div>
        ) : (
          <div className={perLine === "3" ? style.children3 : style.children4}>
            <ChildrenBlock />
          </div>
        )}
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
    text: smartProps.string.withDefault(""),
    theme: smartProps.string.withDefault("white"),
    perLine: smartProps.string.withDefault("3"),
    backLogo: smartProps.bool.withDefault(false),
  },
  setup: {
    title: "Encarts icones",
    parents: [],
  },
});
